import { TFunction } from 'react-i18next';

import { LOGIN_ERROR_STATUS, LOGIN_TASK_STATUS } from 'api/utility/utility.model';

export const loginErrorFormatter = (
  t: TFunction<'translation', undefined>,
  status?: LOGIN_ERROR_STATUS
) => {
  switch (status) {
    case LOGIN_ERROR_STATUS.NOT_FOUND:
      return t('error.login.userNotFound');
    case LOGIN_ERROR_STATUS.CNODE_NOT_AVAILABLE:
      return t('error.login.cnodeNotAvailable');
    case LOGIN_ERROR_STATUS.FORBIDDEN:
      return t('error.login.forbidden');
    default:
      return t('error.login.default');
  }
};

export const loginTaskStatusFormatter = (
  t: TFunction<'translation', undefined>,
  status?: LOGIN_TASK_STATUS
) => {
  switch (status) {
    case LOGIN_TASK_STATUS.REJECTED:
      return t('error.login.rejected');
    case LOGIN_TASK_STATUS.ERROR:
      return t('error.login.error');
    case LOGIN_TASK_STATUS.INVALID_TASK_ID:
      return t('error.login.invalidTaskId');
    default:
      return t('error.login.default');
  }
};
